/**
 * Tiny module-scoped observable for tab bar visibility.
 *
 * Exposed so both the MobileTabBar (owner) and the GlobalMusicPlayer
 * (which needs to drop to the bottom when the bar hides) can stay in sync
 * without passing props through the Navbar → MobileTabBar tree.
 */
import { useEffect, useState } from 'react';

let isHidden = false;
const listeners = new Set();

export const setTabBarHidden = (next) => {
  const val = !!next;
  if (val === isHidden) return;
  isHidden = val;
  listeners.forEach((cb) => cb(val));
};

export const useTabBarHidden = () => {
  const [hidden, setHidden] = useState(isHidden);
  useEffect(() => {
    listeners.add(setHidden);
    return () => {
      listeners.delete(setHidden);
    };
  }, []);
  return hidden;
};
